<template>
  <div class="container">
    <div class="row">

      <div class="col-md-8">
        <h2 class="mt-3">Zoznam objednávok</h2>
      </div>
      <DataTable
          :rowStyle="rowStyle"
          :totalRecords="pagination.totalRecords"
          dataKey="id"
          :value="orders"
          v-model:filters="filters"
          @filter="onFilter"
          filterDisplay="row" :loading="loading"
          :globalFilterFields="globalFilterFields"
          stripedRows
          row-hover
          
          @page="onPage"
          lazy paginator :rows="pagination.rows"
         
          :first="pagination.page"
      >

        <template #header>
          <div class="flex justify-content-end align-items-center">
            <IconField iconPosition="left">
              <InputIcon>
                <i class="pi pi-search mr-2"/>
              </InputIcon>
              <InputText v-model="filters['global'].value" placeholder="Vyhľadať" @keydown.enter="onFilter"/>
            </IconField>
            <PrimevueButton v-if="store.user.role.id !== 2" 
              :label="isFilterActive ? 'Pifema balkóny' : 'Pifema balkóny'" 
              :class="['ml-2', { 'p-button-danger': isFilterActive }]" 
              :icon="isFilterActive ? 'pi pi-filter-slash' : 'pi pi-filter'" 
              @click="toggleFilter"
            />
          </div>
        </template>

        <Column field="orderNumber" header="ID"
                filterField="orderNumber"
                :showFilterMenu="false"
                :filterMenuStyle="{ width: '1rem' }" style="min-width: 1rem">
          <template #body="slotProps">
            {{ slotProps.data.orderNumber }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text"  @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať"/>
          </template>
        </Column>
        <Column field="user.company" header="Firma"
                filterField="user.company"
                :showFilterMenu="false" :filterMenuStyle="{ width: '1rem' }" style="min-width: 1rem"
                v-if="store.user.role.id !== 2">
          <template #body="slotProps">
             {{ slotProps.data.user.company }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text"  @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať"/>
          </template>
        </Column>
        <Column field="user.lastName" header="Odberateľ"
                filterField="user.lastName"
                :showFilterMenu="false" :filterMenuStyle="{ width: '1rem' }" style="min-width: 1rem"
                v-if="store.user.role.id !== 2">
          <template #body="slotProps">
            {{ slotProps.data.user.lastName }} {{ slotProps.data.user.firstName }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text"  @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať"/>
          </template>
        </Column>
        <Column field="customerName" header="Zákazník"
                filterField="customerName"
                :showFilterMenu="false"
                :filterMenuStyle="{ width: '1rem' }" style="min-width: 1rem">
          <template #body="slotProps">
            {{ slotProps.data.customerName }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text"  @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať"/>
          </template>
        </Column>
        <Column field="type.name" header="Zasklenie"></Column>


        <Column field="state" header="Status" :showFilterMenu="false"
                :filterMenuStyle="{ width: '14rem' }" style="min-width: 12rem">
          <template #body="{ data }">
            <Tag :value="data.state" :severity="getStateSeverity(data.state)"/>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <Dropdown v-model="filterModel.value" @change="filterCallback()"
                      :options="statusLabels" placeholder="Vyber stav"
                      class="p-column-filter" style="min-width: 12rem" :showClear="true">
              <template #option="slotProps">
                <Tag :value="slotProps.option" :severity="getStateSeverity(slotProps.option)"/>
              </template>
            </Dropdown>
          </template>
        </Column>

        <Column header="Dátum">
          <template #body="slotProps">
            {{ formatDate(slotProps.data.dateAdd) }}
          </template>
        </Column>
        <Column header="">
          <template #body="slotProps">

            <a  @click="showDetail(slotProps.data.id)" target="_blank">
              <PrimevueButton label="Zobraziť" text raised class="uppercase" icon="pi pi-eye" severity="info"/>
            </a>

          </template>
        </Column>        <Column header="">
          <template #body="slotProps">

            <a  @click="deleteOrder(slotProps.data.id)" target="_blank">
              <PrimevueButton label="Odstrániť" text raised icon="pi pi-trash" severity="danger"/>
            </a>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>

</template>

<script lang="ts">

import Tag from 'primevue/tag';
import {store} from "@/components/store";
import Security from "@/components/security";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import router from "@/router";
import {FilterMatchMode} from "primevue/api";
import Dropdown from "primevue/dropdown";
import InputIcon from "primevue/inputicon";
import notie from "notie/dist/notie";
import PrimevueButton from "primevue/button";
import Utils from '@/components/utils';

export default {
  components: {
    DataTable,
    Column,
    Tag,
    Dropdown,
    InputIcon,
    PrimevueButton

  },
  name: "OrderList",
  data() {
    return {
      isFilterActive: false,
      store,
      orders: [],
      filters: {
        global: {value: null, matchMode: FilterMatchMode.CONTAINS},
        orderNumber: {value: null, matchMode: FilterMatchMode.CONTAINS},
        'user.company': {value: null, matchMode: FilterMatchMode.CONTAINS},
        'user.lastName': {value: null, matchMode: FilterMatchMode.CONTAINS},
        customerName: {value: null, matchMode: FilterMatchMode.CONTAINS},
        state: {value: null, matchMode: FilterMatchMode.EQUALS},
      },
      filterFields: [  {field: 'OrderNumber',value: ""},
                       {field: 'User__Company',value: ""},
                       {field: 'CustomerName',value: ""},
                       {field: 'User__Lastname',value: ""},
                       {field: 'CurrentState__Label',value: ""}
                    ],
      globalFilterFields: ['OrderNumber', 'CustomerName', 'CurrentState__Label'],
      statuses: [],
      statusLabels: [],
      loading: true,
      lazyParams: [],
      pagination: {
        page: 1,
        rows: 7,
        totalRecords: 0, // Total number of records for pagination
        filters: {},
      },
    }
  },
  beforeMount() {
    Security.requireToken();

    this.initFilters()

    if (store.user.role.id !== 2) {
        this.globalFilterFields = ['OrderNumber', 'User__Company', 'User__Lastname', 'CustomerName', 'CurrentState__Label']
    }

    fetch(store.Api_url + "/v1/order-state?query=active:1", Security.requestOptions("GET"))
        .then((response) => response.json())
        .then((responseData) => {
          if (responseData.error) {
            console.log("error:", responseData.message);
            this.$emit('error', responseData.message);
          } else {
            console.log(responseData);
            this.statuses = responseData
            this.statuses.forEach((status) => {
              this.statusLabels.push(status.label)
            });
            this.loading = false
          }
        })
        .catch((error) => {
          alert('chyba pri nacitani stavov: ' + error)
        })

        this.loadComponent()
  },
  methods: {
    rowStyle(data) {
      if (store.user.role.id !== 2) {
      return { backgroundColor: data.user.color };
      }else{
        return {};
      }
    },

    formatDate(dateString: string): string {
      // Parse the date string

      return Utils.parseToSlovakDateTime(dateString);
      
    },
    buttonClicked(rowData) {
      alert(`Button clicked for ${rowData.name}`);
    },
    // load additional order data and store it in store.order obj
    showDetail(orderId) {
      router.push('/order/' + String(orderId))
    },
    deleteOrder(orderId){
      if(confirm("Naozaj chcete ODSTRÁNIŤ objednávku?")){
        Security.requireToken();
        fetch(store.Api_url + "/v1/order/" + String(orderId), Security.requestOptions("DELETE"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                console.log("error:", responseData.message);
                this.$emit('error', responseData.message);
              } else {
                // Make a copy of the orders array to avoid mutating during iteration
                const updatedOrders = [...this.orders];

                // Find and remove the order with the matching ID
                const indexToRemove = updatedOrders.findIndex(order => order.id === orderId);
                if (indexToRemove !== -1) {
                  updatedOrders.splice(indexToRemove, 1);
                }

                // Update the UI with the modified orders array
                this.orders = updatedOrders;
                notie.alert({
                  type: 'success',
                  text: "Objednávka bola odstránená",
                  position: "bottom"
                })
              }
            })
            .catch((error) => {
              alert('chyba pri nacitani objednavok: ' + error)
            })
      }
    },
    getStateSeverity(reference: string): string {
      switch (reference) {
        case "Odoslaná":
          return "danger";
        case "Vo výrobe":
          return "warning";
        case "Pripravená na prevzatie":
          return "success";
        case "Ukončená":
          return "contrast";
        default:
          return "info";
      }
    },

    loadComponent(){

      this.pagination.page = 0
      this.pagination.totalRecords = 0

      //console.log('Load component',this.pagination.filters);

      this.loadLazyData()
    },

    onPage(event) {
        this.pagination.page = event.first; // PrimeVue page is zero-based; adjust if your API is 1-based

        this.loadLazyData();
    },

    initFilters(){
        this.pagination.filters.filterFields = this.filterFields
        this.pagination.filters.global = ""
        this.pagination.filters.table = "order"
        this.pagination.filters.globalFilterFields = this.globalFilterFields;
    },

    onFilter(event) {
        if(event.filters){
          //console.log("Event:", event.filters['user.lastName']);
          this.pagination.filters.filterFields = [ {field: 'OrderNumber',value: event.filters.orderNumber.value ? event.filters.orderNumber.value : ""},
                                                    {field: 'CustomerName',value: event.filters.customerName.value ? event.filters.customerName.value: ""},
                                                    {field: 'User__Company',value: event.filters['user.company'].value ? event.filters['user.company'].value: ""},
                                                    {field: 'User__Lastname',value: event.filters['user.lastName'].value ? event.filters['user.lastName'].value: ""},
                                                    {field: 'CurrentState__Label',value: event.filters.state.value ? event.filters.state.value : ""}
                                                  ];
          this.pagination.filters.global = event.filters.global.value
        }else{
          this.pagination.filters.filterFields = this.filterFields
          this.pagination.filters.global = this.filters.global.value
          //console.log("Filters:", this.pagination.filters);
        }
        this.pagination.filters.globalFilterFields = this.globalFilterFields;
        //this.pagination.page = 0;  // Reset to the first page
        
        this.loadComponent();
    },

    toggleFilter() {
      if (this.isFilterActive) {
        // Ak je filter aktívny, resetuje sa
        this.resetFilter();
      } else {
        // Ak filter nie je aktívny, aplikuje sa
        this.applyFilter();
      }
      // Prepnúť stav filtra
      this.isFilterActive = !this.isFilterActive;
    },
    applyFilter() {
      // Logika na aplikovanie filtra
      this.pagination.filters.filterFields = [ 
            {field: 'User__Role__Name',value: "správca"},
      ];
      this.pagination.filters.global = ""
      this.pagination.filters.globalFilterFields = [];
      
      this.loadComponent();
    },
    resetFilter() {
      // Logika na resetovanie filtra
      this.initFilters()
      this.loadComponent();
    },
    
    loadLazyData() {
      this.loading = true;

      let queryParams = `&limit=${this.pagination.rows}&offset=${this.pagination.page}`;

      let query = "/data-filter?sortby=id&order=desc&query=active:1"
      if (store.user.role.id === 2) {
        query = "/data-filter?sortby=id&order=desc&query=active:1,user_id:" + String(store.user.id)
      }

      console.error("Filters:", this.pagination);

      fetch(store.Api_url + query + queryParams, Security.requestOptions("POST",this.pagination.filters))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              console.log("error:", responseData.message);
              this.$emit('error', responseData.message);
            } else {
              if(!responseData.data){
                notie.alert({
                  type: 'warning',
                  text: "Žiadne objednávky nenájdené",
                  position: "bottom"
                })
              }else{
            
                this.orders = responseData.data
                // Corrected forEach usage
                this.orders.forEach((order) => {
                  order.state = order.currentState.label;
                });
                this.pagination.totalRecords = responseData.totalRecords
                this.loading = false
                console.log('total',this.pagination.totalRecords);
              }
            }
          })
          .catch((error) => {
            alert('chyba pri nacitani objednavok: ' + error)
      })


    }
  }

}
</script>

<style>
.p-datatable-thead .p-filter-column{
  padding:0;
}
.p-inputtext{
  padding: 0.3rem;
}
.p-column-filter .p-inputtext{
  padding: 0.3rem;
}
.p-dropdown-label.p-inputtext.p-placeholder{
  padding: 0.3rem;
}
.p-datatable .p-datatable-thead > tr > th{
  padding: 0.5rem;
}

.p-datatable button{
  border-radius: 6px;
  padding: 0.5rem 1rem;
}
.p-datatable .p-datatable-tbody > tr > td {

  padding: 0.5rem 0.5rem;
}

</style>